import { render, staticRenderFns } from "./UserEditSocial.vue?vue&type=template&id=74a6c71c&"
import script from "./UserEditSocial.vue?vue&type=script&lang=js&"
export * from "./UserEditSocial.vue?vue&type=script&lang=js&"
import style0 from "./UserEditSocial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports